import { render, staticRenderFns } from "./Airlines.vue?vue&type=template&id=fba73d34&scoped=true"
import script from "./Airlines.vue?vue&type=script&lang=js"
export * from "./Airlines.vue?vue&type=script&lang=js"
import style0 from "./Airlines.vue?vue&type=style&index=0&id=fba73d34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba73d34",
  null
  
)

export default component.exports